import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'v1/etr'

const etr = new ApiCore({
	remove: true,
	url: url
})

etr.savedAddress = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/saveAddress`, payload)
		.then(handleResponse)
		.catch(handleError);
}

etr.updateSavedAddress = (payload, id) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/${id}`, payload)
		.then(handleResponse)
		.catch(handleError);
}

etr.getSavedAddress = () => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/saveAddress`)
		.then(handleResponse)
		.catch(handleError);
}

etr.deleteSavedAddress = (id) => {
	return axios
		.delete(`${apiProvider.BASE_URL}/${url}/${id}`)
		.then(handleResponse)
		.catch(handleError);
}

etr.transferHoldership = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/transferHolder`, payload, { timeout: 120000 })
		.then(handleResponse)
		.catch(handleError);
}

etr.endorseOwnerAndHolder = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/endorseOwnerAndHolder`, payload, { timeout: 120000 })
		.then(handleResponse)
		.catch(handleError);
}

etr.transferOwnership = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/transferOwner`, payload, { timeout: 120000 })
		.then(handleResponse)
		.catch(handleError);
}

etr.nominateOwner = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/nominateOwner`, payload, { timeout: 120000 })
		.then(handleResponse)
		.catch(handleError);
}

etr.endorseOwner = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/endorseOwner`, payload, { timeout: 120000 })
		.then(handleResponse)
		.catch(handleError);
}

etr.editRequest = (payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/request-edit`, payload, { timeout: 120000 })
		.then(handleResponse)
		.catch(handleError);
}

etr.surrenderTT = (payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/surrenderTT`, payload, { timeout: 120000 })
		.then(handleResponse)
		.catch(handleError);
}

etr.transport = (json, file) => {
	let formData = new FormData();
	formData.append("file", file);
	for (let key in json) {
		if (json[key])
			formData.append(key, json[key]);
	}

	return axios
		.post(`${apiProvider.BASE_URL}/${url}/transport`, formData)
		.then(handleResponse)
		.catch(handleError);
};

etr.paginateTransferableDocumentList = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/transferableDocument`, { params })
		.then(handleResponse)
		.catch(handleError);
}

etr.uploadTTFile = (file) => {
	let formData = new FormData();
	formData.append("files", file);
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/files`, formData, { timeout: 120000 })
		.then(handleResponse)
		.catch(handleError);
}

etr.getRecordTransferableDetails = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/transferableDocument/${params}`, { timeout: 120000 })
		.then(handleResponse)
		.catch(handleError);
}

etr.getTransferableRecordBlockchainDetails = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/transferableDocument/${params}/blockchain-details`, { timeout: 120000 })
		.then(handleResponse)
		.catch(handleError);
}

etr.getTransferableRecordEndorsechainDetails = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/transferableDocument/${params}/getEndorsementChain`, { timeout: 120000 })
		.then(handleResponse)
		.catch(handleError);
}

etr.updateAuditTrail = () => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/print`, {})
		.then(handleResponse)
		.catch(handleError);
}

etr.deleteRecordTransferableDetails = (params) => {
	return axios
		.delete(`${apiProvider.BASE_URL}/${url}/transferableDocument/${params}`)
		.then(handleResponse)
		.catch(handleError);
}

etr.checkOrgHasTermClause = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/checkTermClause/${params}`)
		.then(handleResponse)
		.catch(handleError);
}

etr.deleteMultipleRecordsETR = (params) => {
	return axios
		.delete(`${apiProvider.BASE_URL}/${url}/transferableDocument`, { data: params })
		.then(handleResponse)
		.catch(handleError);
}

etr.updateRecordTransferableDetails = (params, payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/transferableDocument/${params}`, payload)
		.then(handleResponse)
		.catch(handleError);
}

etr.activityLog = (id) => {
	return axios
		.get(`${apiProvider.BASE_URL}/v1/eventLog/transferableRecord/${id}`)
		.then(handleResponse)
		.catch(handleError);
};

etr.approveSurrender = (params, payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/surrender/${params}/approve`, payload)
		.then(handleResponse)
		.catch(handleError);
}

etr.rejectSurrender = (params, payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/surrender/${params}/reject`, payload)
		.then(handleResponse)
		.catch(handleError);
}

etr.rejectTransferOwner = (params, payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/rejectTransferOwner/${params}`, payload)
		.then(handleResponse)
		.catch(handleError);
}

etr.rejectTransferHolder = (params, payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/rejectTransferHolder/${params}`, payload)
		.then(handleResponse)
		.catch(handleError);
}

etr.rejectTransferOwnerHolder = (params, payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/rejectTransferOwnerHolder/${params}`, payload)
		.then(handleResponse)
		.catch(handleError);
}

etr.fetchOrgTermClause = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${params}`)
		.then(handleResponse)
		.catch(handleError);
}

etr.fetchOrgTermClauseExternal = (params) => {
	return axios
		.get(`${params}`)
		.then(handleResponse)
		.catch(handleError);
}

export default etr
